import React from 'react';
import { every, some, snakeCase, reduce, isEqual } from 'lodash';
import { getActualFilters } from './refinementUtils';

const horseNameKey = 'horseName';

// TODO: it might be moved to config
export const shortlistStateKey = 'shortlist';
export const shortlistPagerLength = 5;

export function getInitialRefinement() {
    return {
        horseName: null,
        horseSex: null,
        horseAge: null,
        sireName: null,
        damName: null,
        sireOfDamName: null,
        vendor: null,
        saleName: null,
        price: false,
        entered: false,
        withNotes: false
    };
}

export function isFilteringEmpty(refinement) {
    return every(refinement, value => !value && value !== 0);
}

export function isRefinementUsed(refinement) {
    return !isEqual(refinement, getInitialRefinement());
}

export function isSaleNameFilteringEmpty(refinement) {
    return !refinement.sale;
}

export function isHorseNameFilterDisabled(refinement) {
    return some(refinement, (value, key) => key !== horseNameKey && value);
}

export function getSearchFilterOptionsKey(filterKey) {
    return `${filterKey}Options`;
}

export function isCommonFilterDisabled(refinement) {
    return refinement[horseNameKey];
}

export function getSearchQueryParam(
    refinement,
    excludedKey,
    actualFiltersGetter = getActualFilters
) {
    return reduce(
        actualFiltersGetter(refinement, [excludedKey]),
        (obj, value, key) => Object.assign({
            [snakeCase(key)]: value
        }, obj),
        {}
    );
}

export function getSearchQueryParams(
    refinement,
    page,
    excludedKey,
    actualFiltersGetter
) {
    return {
        page,
        refine: getSearchQueryParam(refinement, excludedKey, actualFiltersGetter)
    };
}

/**
 * Function, that generates output of user's search history
 * @param refinement
 * @param refinementHistory
 * @param data
 * @returns {string} User's filter history in string
 */
export function getShortlistFiltersLabel({ refinement, refinementHistory, data }) {
    const excludedFilters = ['from', 'to'];
    const actualFilters = getActualFilters(refinement, excludedFilters);
    return refinementHistory
        .filter(({ key }) => actualFilters.hasOwnProperty(key))
        .map(({ key, value }) => {
            switch (key) {
                case 'lotNo':
                    return `lot ${value}`;
                case 'entered':
                    return 'Show only lots with entries';
                case 'withNotes':
                    return 'Show only lots with notes';
                case 'price':
                    return 'Show only sold lots';
                case 'name':
                case 'sire':
                case 'dam':
                case 'damsire':
                case 'vendor':
                case 'buyer':
                    return value;
                default: {
                    const options = data[getSearchFilterOptionsKey(key)];
                    const option = options.find(item => item.value === value) ||
                        { name: value || '' };
                    return option.name;
                }
            }
        })
        .join(', ');
}

/**
 * Function, that passes down properties
 * @param Component
 * @param makeProps
 * @returns {{}}
 */
export function withProps(Component, makeProps = props => ({ ...props })) {
    return (props) => <Component {...props} {...makeProps(props)} />;
}



// WEBPACK FOOTER //
// ./src/js/helpers/shortlistUtils.js